import { render, staticRenderFns } from "./uiAudioPlayer.vue?vue&type=template&id=cb241206"
import script from "./uiAudioPlayer.vue?vue&type=script&lang=js"
export * from "./uiAudioPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports